module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_01-bfb9cb01947b09c8606d4ed304f0cb0e.png";